<div class="lab-container">
  <nz-layout class="labs-content" ngClass="no-secondary-header-content">
    <!-- Writing separate left panel for labs page as its api for getting left panel data 
      is different, so it will lead to lot of if conditions in left-panel-component
      So it makes sense to keep it separate.
    -->
    <ng-container
      *ngIf="
        (isLabsPage && labsPageService.labsUser.is_lab_access) ||
        (!isLabsPage && labsPageService.labsUser.is_apitutorial_access)
      "
    >
      <nz-sider
        ngClass="leftSider"
        nzTheme="light"
        nzCollapsible
        [(nzCollapsed)]="isCollapsed"
        [nzCollapsedWidth]="0"
        [nzZeroTrigger]="siderArrowTemplate"
      >
        <div title="Go to VA Labs" class="valab_link">
          <a [routerLink]="['/labs']">VA Labs Overview</a>
        </div>
        <div class="avilable_report">
          <label>
            Available Reports
          </label>
        </div>
        <ul class="panel-menu" nz-menu nzMode="inline">
          <ng-container
            *ngIf="loading"
            [ngTemplateOutlet]="loader"
          ></ng-container>
          <ng-container *ngIf="!loading">
            <div class="shortcuts-section">
              <li
                *ngFor="let item of labsUrls | keyvalue"
                class="group-name"
                nz-submenu
                [nzTitle]="item.key"
                [nzOpen]="true"
              >
                <ul>
                  <li
                    *ngFor="let data of item.value"
                    routerLink="/{{ mainRoute }}/{{ data.pagename }}"
                    (click)="onLabUrlClick(data)"
                    class="group-child"
                    nz-menu-item
                    [nzSelected]="data.id === selected"
                  >
                    <a>
                      {{ data.name }}
                    </a>
                  </li>
                </ul>
              </li>
            </div>
          </ng-container>
        </ul>
      </nz-sider>
    </ng-container>

    <nz-content class="lab-content">
      <ng-container *ngIf="iframeLoading">
        <div ng-show="iframeLoading" class="iframe-container">
          <div class="loader"></div>
        </div>
      </ng-container>
      <ng-container *ngIf="!notFound && notExcel">
        <iframe
          id="labHolder"
          [src]="frameUrl"
          [style.visibility]="!iframeLoading"
          frameborder="0"
          allowfullscreen
          width="100%"
          height="100%"
          (load)="onLabFrameLoad()"
        >
        </iframe>
      </ng-container>
      <ng-container *ngIf="!notFound && !notExcel">
        <app-xl-template-library></app-xl-template-library>
      </ng-container>
      <ng-container *ngIf="notFound">
        <h1>{{ notFoundMsg }}</h1>
      </ng-container>
    </nz-content>
  </nz-layout>
</div>

<ng-template #siderArrowTemplate>
  <va-icon
    *ngIf="isCollapsed"
    name="arrow-circle-right"
    class="fa fa-md"
  ></va-icon>
  <va-icon
    *ngIf="!isCollapsed"
    name="arrow-circle-left"
    class="fa fa-md"
  ></va-icon>
</ng-template>

<ng-template #loader>
  <li *ngFor="let dummySection of [0, 1, 2, 3, 4, 5]">
    <nz-skeleton
      [nzTitle]="true"
      [nzActive]="true"
      [nzParagraph]="false"
    ></nz-skeleton>
  </li>
</ng-template>
